let isAnimating = false;

var teradekAPI = {};

teradekAPI.replaceTags = () => {
  let domParser = new DOMParser;
  $('.bc-sf-filter-option-value').each((k, value) => {
    let parsedValue = domParser.parseFromString(value.innerHTML, 'text/html').body.innerText
    if (tagMap.hasOwnProperty(parsedValue)) {
      value.innerHTML = tagMap[parsedValue]
    }
  })
  $('.selected-type strong').each((k, value) => {
    let parsedValue = domParser.parseFromString(value.innerHTML, 'text/html').body.innerText
    if (tagMap.hasOwnProperty(parsedValue)) {
      value.innerHTML = tagMap[parsedValue]
    }
  })
}


teradekAPI.setOptionsFromVariantParam = (product, variantId) => {
  if (!product) {
    return console.log("no product yet")
  }
  let variant = product.variants.edges.find(({node}) => {
    let variant = node;
    return parseInt(variant.id) === parseInt(variantId)
  })
  let options = variant.title.split(" / ")
  options.forEach((option, optionIndex) => {
    $(`[data-product-option="${optionIndex}"]`)[0].value = option
  })
}


teradekAPI.hideSideCart = () => {
  if (isAnimating) {
    return;
  }
  isAnimating = true;
  $('body').css({ overflow: "auto" })
  $('.cart-form').animate({
    right: "-500px"
  }, 250, () => {
    $('#shopify-section-sidecart').animate({
      opacity: 0
    }, 150, () => {
      $('#shopify-section-sidecart').css({ display: "none", right: "-1350px", zIndex: -1 })
      isAnimating = false;
    });
  });
}


teradekAPI.openSideCart = () => {
  if (isAnimating) {
    return;
  }

  isAnimating = true;
  // $('body').css({ overflow: "hidden" })
  $('#shopify-section-sidecart').css({ display: "inline-block", right: "0px", zIndex: 999 })
  $('#shopify-section-sidecart').animate({
    opacity: 1
  }, 150, () => {
    $('.cart-form').animate({
      right: "0px"
    }, 250, () => {
      isAnimating = false;
    });
  });
}


teradekAPI.toggleCart = () => {
  if ($('#shopify-section-sidecart')[0].style.display === "inline-block") {
    teradekAPI.hideSideCart()
  } else {
    teradekAPI.openSideCart()
  }
}


teradekAPI.getQueryFilters = () => {
  // let options = $('#bc-sf-filter-options-wrapper');
  let qs = teradekAPI.getQueryString();
  let optionKeys = Object.keys(qs).filter(each => each.slice(0, 7) === 'pf_opt_')
  let compatFilters = qs['pf_t_compatability'] && qs['pf_t_compatability'].filter(each => each.slice(0,7) === "COMPAT_")
  //.filter(each => qs[each].slice(0,7) === "COMPAT_")
  let optionFilters = optionKeys.map(key => {
    let title = key.slice('pf_opt_'.length).toLowerCase().replace(/_/g, ' ');
    return { key: key, values: qs[key], title: title }
  })
  return ({optionFilters, compatFilters});
}


teradekAPI.getVariantFromOptionFilters = (product, originalTags, mergedTags) => {
  // console.log("product11" ,product.options);
  // console.log("originalTags",originalTags)
  let queryFilters = teradekAPI.getQueryFilters();
  let optionFilters = queryFilters.optionFilters;
  let compatFilters = queryFilters.compatFilters;
  let variants = product && product.variants;
  if (!variants) {
    // let url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?product=" + product.id
    // compareApp.previousUrl = window.location.href
    // window.history.pushState({path:url},'',url);
    return null;
  }

  //This takes the optionFilters and matches them to the order of the product
  let sortedProductOptions = product.options.reduce((optionAcc, option) => {
    if (option) {
      let possibleChoices = optionFilters.filter(optionFilter => {
        return optionFilter.title === option.replace(/_/g, ' ').toLowerCase();
      })
        .map(optionFilter => optionFilter.values);
      if (!possibleChoices.length) {
        optionAcc.push([]);
      } else {
        optionAcc.push(...possibleChoices);
      }
      return optionAcc
    } else {
      return optionAcc;
    }
  }, []);

  if (variants.edges) {
    variants = variants.edges
  }
  let sortedVariants = variants.filter((variant) => {
    if (variant.node) {
      variant = variant.node
    }
    // let variant = node;
    if (!compatFilters || !compatFilters.length) {
      return true;
    }
    let validVariants = originalTags && originalTags.filter(each => compatFilters.includes(each.split('--')[0])).map(each => each.split('--')[1])
    vueModalApp.validVariants = validVariants;

    return validVariants.includes(variant.sku)
  }).reduce((variantAcc, variant, variantIndex) => {
    let matchesOption1 = variant.option1 && sortedProductOptions[0].indexOf(variant.option1.toString())
    let matchesOption2 = variant.option2 && sortedProductOptions[1].indexOf(variant.option2.toString())
    let matchesOption3 = variant.option3 && sortedProductOptions[2].indexOf(variant.option3.toString())
    let matchesLength = [matchesOption1, matchesOption2, matchesOption3].filter(each => each > -1).length;
    variantAcc.push({ matchesLength, variant });
    return variantAcc
  }, [])
    .sort((a, b) => b.matchesLength - a.matchesLength);

    if (sortedVariants[0]) {
      return sortedVariants[0].variant
    } else {
      return null
    }


}


teradekAPI.setLinePrice = (item) => {
  if (item) {
    $(`.cartitems article[data-cartitem-id=${item.id}] span[data-cartitem-total]`).text((item.line_price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" }));
  }
}


teradekAPI.getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


teradekAPI.getQueryString = (path) => {
  var qs = (function (a) {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split('=', 2);
      if (p.length == 1)
        b[p[0]] = "";
      else
        if (!b[p[0]]) {
          b[p[0]] = [];
          b[p[0]].push(decodeURIComponent(p[1].replace(/\+/g, " ")));
        } else {
          b[p[0]].push(decodeURIComponent(p[1].replace(/\+/g, " ")));
        }

    }
    return b;
  })(!path ? window.location.search.substr(1).split('&') : path.split("?")[1].split("&"));
  // })(!path ? window.location.search.substr(1).split('&') : path.split("?").length > 0 ? path.split("?")[1].split("&") : []);
  return qs
}


teradekAPI.updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}


teradekAPI.recalculateRequirements = () => {
  $.ajax({
    type: 'GET',
    url: '/cart?view=cart-info.json',
    success: function (resp) {
      try {
        function add(accumulator, a) {
          return parseInt(accumulator) + parseInt(a);
        }
        // return;
        let cart = JSON.parse(resp)
        let currentValues = {};
        cart.items.forEach(eachCartItem => {
          let requirements = "";
          let extraInfo = allRequirements[eachCartItem.id]
  
          if (extraInfo) {
            let requires = extraInfo && extraInfo.requires
            Array.isArray(requires) && requires.length > 0 && requires.forEach((eachRequirement, eachRequirementIndex) => {
              let tags = eachRequirement.tags;
              let mainTag = tags[0].toLowerCase();
              let productsWithTags = cart.items.filter((item) => {
                return tags.some(each => {
                  return item.product.tags.toLowerCase().split(',').includes(each.toLowerCase())
                })
              })
              let uid = eachCartItem.sku.concat(eachRequirementIndex);
              let currentQuantity = currentValues.hasOwnProperty(mainTag) ? currentValues[mainTag] : 0
              let productWithTagsQuantity = productsWithTags.length > 0 ? productsWithTags.map(each => each.quantity).reduce(add) - currentQuantity : 0;
              let quantity = eachRequirement.quantity * eachCartItem.quantity
              let color = eachRequirement.optional ? "#cc9648" : "#ca5050";
              if (eachRequirement.noQuantity && productWithTagsQuantity > 0) {
                requirements += `
                <div class="sidecart-item--requirement">
                <i style="color: green;" class="far fa-check-circle"></i><a style="color: green;" class="sidecart-item--link" ${eachRequirement.href ? "href=/collections/" + eachRequirement.href : ""}><span><span class="sidecart-item--requirement-message"><span class="sidecart-item--requirement-message">${eachRequirement.message}</span></span></a>
                </div>`
              } else if (!currentValues.hasOwnProperty(mainTag)) {
                if (parseInt(productWithTagsQuantity) >= quantity) {
                  currentValues[mainTag] = parseInt(quantity);
                  requirements += `
                  <div class="sidecart-item--requirement">
                  <i style="color: green;" class="far fa-check-circle"></i><a style="color: green;" class="sidecart-item--link" ${eachRequirement.href ? "href=/collections/" + eachRequirement.href : ""}><span><span class="sidecart-item--requirement-message"><span class="sidecart-item--requirement-message">${eachRequirement.message}</span>${eachRequirement.noQuantity === true ? "" : quantity + ` / <span data-requirement-tag="${mainTag}">${quantity}</span>`}</span></a>
                  </div>`
                  // requirements += '<div><a href="/collections/accessories?pf_t_compatibility=' + tag + '"><p>' + message + '   ' + quantity + '/' + cartItem.quantity * quantity + '</p></a></div>'
                  productWithTagsQuantity = (parseInt(productWithTagsQuantity) - parseInt(quantity))
                } else {
                  let prevValue = currentValues[mainTag] ? parseInt(currentValues[mainTag]) : 0;
                  currentValues[mainTag] = prevValue + parseInt(productWithTagsQuantity);
                  requirements += `
                  <div class="sidecart-item--requirement">
                  ${eachRequirement.optional ? "" : `<i style="color: ${color};" class="far fa-times-circle"></i>`}<a style="color: ${color};" class="sidecart-item--link" ${eachRequirement.href ? "href=/collections/" + eachRequirement.href : ""}><span><span class="sidecart-item--requirement-message">${eachRequirement.message}</span> ${eachRequirement.noQuantity === true ? "" : productWithTagsQuantity + ` / <span data-requirement-tag="${mainTag}">${quantity}</span>`}</span></a>
                  </div>`
                  // requirements += '<div><a href="/collections/accessories?pf_t_compatibility=' + tag + '"><p>' + message + '   ' + parseInt(productWithTagsQuantity) + '/' + cartItem.quantity * quantity + '</p></a></div>'
                  productWithTagsQuantity = 0
                }
              } else {
                if (parseInt(productWithTagsQuantity) >= quantity) {
                  currentValues[mainTag] = parseInt(currentValues[mainTag]) + parseInt(quantity);
                  requirements += `
                  <div class="sidecart-item--requirement">
                  <i style="color: green;" class="far fa-check-circle"></i><a style="color: green;" class="sidecart-item--link" ${eachRequirement.href ? "href=/collections/" + eachRequirement.href : ""}><span><span class="sidecart-item--requirement-message"><span class="sidecart-item--requirement-message">${eachRequirement.message}</span>${eachRequirement.noQuantity === true ? "" : productWithTagsQuantity + ` / <span data-requirement-tag="${mainTag}">${quantity}</span>`}</span></a>
                  </div>`
                  // requirements += '<div><a href="/collections/accessories?pf_t_compatibility=' + tag + '"><p>' + message + '   ' + quantity + '/' + cartItem.quantity * quantity + '</p></a></div>'
                  productWithTagsQuantity = (parseInt(productWithTagsQuantity) - parseInt(quantity))
                } else {
                  currentValues[mainTag] = parseInt(currentValues[mainTag]) + parseInt(productWithTagsQuantity);
                  requirements += `
                    <div class="sidecart-item--requirement">
                    ${eachRequirement.optional ? "" : `<i style="color: ${color};" class="far fa-times-circle"></i>`}<a style="color: ${color};" class="sidecart-item--link" ${eachRequirement.href ? "href=/collections/" + eachRequirement.href : ""}><span><span class="sidecart-item--requirement-message">${eachRequirement.message}</span> ${eachRequirement.noQuantity === true ? "" : productWithTagsQuantity + ` / <span data-requirement-tag="${mainTag}">${quantity}</span>`}</span></a>
                    </div>`
                  // requirements += '<div><a href="/collections/accessories?pf_t_compatibility=' + tag + '"><p>' + message + '   ' + parseInt(productWithTagsQuantity) + '/' + cartItem.quantity * quantity + '</p></a></div>'
                  productWithTagsQuantity = 0
                }
              }
            })
          } else {
          }
          let tags = eachCartItem.tags.split(",")
          let linkedTags = tags.filter(each => {
            return (each.indexOf("LINKED-MALE") > -1) || (each.indexOf("LINKED-FEMALE") > -1)
          })
          linkedTags.forEach(linkedTag => {
            let switchedTag = linkedTag;
            if (linkedTag.indexOf("--LINKED-MALE") > -1) {
              switchedTag = linkedTag.split('--LINKED-MALE')[0] + "--LINKED-FEMALE"
              let linkTag = linkedTag.split('--LINKED-MALE')[0] + "--LINK"
              let formattedTag = tagMap.hasOwnProperty(linkTag) ? tagMap[linkTag] : linkTag;
              requirements += `
              <div class="sidecart-item--requirement">
              <a style="color: #cc9648;" class="sidecart-item--link" href="/collections/all?pf_t_compatibility=${linkTag}"><span><span class="sidecart-item--requirement-message">${formattedTag}</span></span></a>
              </div>`
            } else if (linkedTag.indexOf("--LINKED-FEMALE") > -1) {
              switchedTag = linkedTag.split('--LINKED-FEMALE')[0] + "--LINKED-MALE"
              let linkTag = linkedTag.split('--LINKED-FEMALE')[0] + "--LINK"
              let formattedTag = tagMap.hasOwnProperty(linkTag) ? tagMap[linkTag] : linkTag;
              requirements += `
                    <div class="sidecart-item--requirement">
                    <a style="color: #cc9648;" class="sidecart-item--link" href="/collections/all?pf_t_compatibility=${linkTag}"><span><span class="sidecart-item--requirement-message">${formattedTag}</span></span></a>
                    </div>`
            } else if (linkedTag.indexOf("--LINKED-FEMALE") > -1) {
              switchedTag = linkedTag.split('--LINKED-FEMALE')[0] + "--LINK"
            } else if (linkedTag.indexOf("--LINKED-MALE") > -1) {
              switchedTag = linkedTag.split('--LINKED-MALE')[0] + "--LINK"
            } else if (linkedTag.indexOf("--DIRECT-LINKED-MALE") > -1) {
              switchedTag = linkedTag.split('--DIRECT-LINKED-MALE')[0] + "--DIRECT-LINKED-FEMALE"
            } else if (linkedTag.indexOf("--DIRECT-LINKED-FEMALE") > -1) {
              switchedTag = linkedTag.split('--DIRECT-LINKED-FEMALE')[0] + "--DIRECT-LINKED-MALE"
            } else if (linkedTag.indexOf("--DEADEND-LINKED-FEMALE") > -1) {
              switchedTag = linkedTag.split('--DEADEND-LINKED-FEMALE')[0] + "--DEADEND-LINK"
            } else if (linkedTag.indexOf("--DEADEND-LINKED-MALE") > -1) {
              switchedTag = linkedTag.split('--DEADEND-LINKED-MALE')[0] + "--DEADEND-LINK"
            }
            let formattedTag = tagMap.hasOwnProperty(switchedTag) ? tagMap[switchedTag] : switchedTag;
            requirements += `
                  <div class="sidecart-item--requirement">
                  <a style="color: #cc9648;" class="sidecart-item--link" href="/collections/all?pf_t_compatibility=${switchedTag}"><span><span class="sidecart-item--requirement-message">${formattedTag}</span></span></a>
                  </div>`
          })
  
          if (window.location.pathname.split('/')[1] === "cart") {
            $(`.sidecart-products .sidecart-product[data-cartitem-id=${eachCartItem.id}] div.sidecart-item--requirements`).remove()
            $(`.sidecart-products .sidecart-product[data-cartitem-id=${eachCartItem.id}] .sidecart-products--content`).append(`
            <div class="sidecart-item--requirements">
              ${!!requirements ? `<p style="text-align: right; margin: 0; font-size: 0.9em; border-bottom: 1px solid black; width: 100px; margin: 0 25px 0 auto;">Recommended</p>` : ""}
              ${requirements}
            </div>
            `)
          } else {
            $(`.sidecart-products .sidecart-product[data-cartitem-id=${eachCartItem.id}] div.sidecart-item--requirements`).remove()
            $(`.sidecart-products .sidecart-product[data-cartitem-id=${eachCartItem.id}] .sidecart-products--content`).append(`
              <div class="sidecart-item--requirements">
                ${!!requirements ? `<p style="text-align: right; margin: 0; font-size: 0.9em; border-bottom: 1px solid black; width: 100px; margin: 0 25px 0 auto;">Recommended</p>` : ""}
                ${requirements}
              </div>
            `)
          }
        })
      } catch(err) {
        Sentry.captureException(err);
      }
    },
    error: function (err) {
      Sentry.captureException(err);
      console.warn('ERROR', err);
    }
  })

}


teradekAPI.getGraphQLQuery = (query) => {
  return new Promise((resolve, reject) => {
    // console.log('axios', query);
    axios({
      headers: { 'X-Shopify-Storefront-Access-Token': "62dc5c47a0fa65f98ebcb30c7c3b746e" },
      method: "post",
      url: `https://cs-io.myshopify.com/api/2020-04/graphql.json`,
      data: {
        query: query
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        Sentry.captureException(err);
        reject(err)
      })
  })
}


teradekAPI.parseProductResponse = (productResponse) => {
  // console.log('productResponse', productResponse.data.products);
  return new Promise((resolve, reject) => {
    let products = productResponse.data.products;
    if (products && products.edges.length > 0) {
      let product = products.edges[0].node;
      //let decodedBase64ProductID = atob(product.id)
      let decodedBase64ProductID = product.id;
      let productId = decodedBase64ProductID.replace('gid://shopify/Product/', '')
      // let productId = product.id.replace('gid://shopify/Product/', '')
      product.id = productId
      product.variants.edges.forEach(({node}) => {
        //let decodedBase64VariantID = atob(node.id)
        let decodedBase64VariantID = node.id
        let variantId = decodedBase64VariantID.replace('gid://shopify/ProductVariant/', '')
        // let variantId = node.id.replace('gid://shopify/ProductVariant/', '')
        node.id = variantId
      })
      resolve(product)
    } else {
      reject("Could not find product")
    }
  });
}


teradekAPI.getUrlParameter = (sParam) => {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++)
  {
      var sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] == sParam)
      {
          return sParameterName[1];
      }
  }
}


teradekAPI.getProductInfoById = (productId) => {
  return new Promise((resolve, reject) => {
    // console.log('productId-', productId);
    let query = storefrontQueries.getProductById(productId)
    return teradekAPI.getGraphQLQuery(query)
      .then(res => {
        let products = res.data.products;
        if (products && products.edges.length > 0) {
          let product = products.edges[0].node;
            // console.log('product---', product);
          let decodedBase64ProductID = product.id
           // console.log('decodedBase64ProductID---', decodedBase64ProductID);
          //let decodedBase64ProductID = atob(product.id)
          let productId = decodedBase64ProductID.replace('gid://shopify/Product/', '')
          // let productId = product.id.replace('gid://shopify/Product/', '')
          product.id = productId
          //  product.variants.edges.forEach(({node}) => {
          //   console.log('product---', node);
          //   let decodedBase64VariantID = node.id
          //   let productId = decodedBase64VariantID.replace('gid://shopify/Product/', '')
          //   product.id = productId
          //   resolve(product)
          // })
          product.variants.edges.forEach(({node}) => {
            // console.log('node---', node);
            //let decodedBase64VariantID = atob(node.id)
            let decodedBase64VariantID = node.id
            let variantId = decodedBase64VariantID.replace('gid://shopify/ProductVariant/', '')
            // let variantId = node.id.replace('gid://shopify/ProductVariant/', '')
            node.id = variantId
          })
          resolve(product)
        }
        else if( productId == '6708823916677'){
          //temporary hack for Indie 5
          window.location.href = 'https://smallhd.com/products/indie-5'
        }
        else {
          reject("Could not find product!")
        }
      })
      .catch(err => {
        Sentry.captureException(err);
        console.log("err", err)
        reject(err)
      });
  });
}


teradekAPI.getProductInfoByHandle = (productHandle) => {
  return new Promise((resolve, reject) => {
    let query = storefrontQueries.getProductByHandle(productHandle)
    return teradekAPI.getGraphQLQuery(query)
      .then(response => {
        let product = response.data.productByHandle
        if (product) {

          console.log("product ID is: ", product.id);
          //let decodedBase64ProductID = atob(product.id)
          let decodedBase64ProductID = product.id;
          console.log("decodeBase64ProductID: ", decodedBase64ProductID);
          let productId = decodedBase64ProductID.replace('gid://shopify/Product/', '')
          // let productId = product.id.replace('gid://shopify/Product/', '')
          product.id = productId
          console.log('productID: ', productId);
          product.variants.edges.forEach(({node}) => {
            //let decodedBase64VariantID = atob(node.id)
            let decodedBase64ProductID = product.id;
            let decodedBase64VariantID = product.id;
            let variantId = decodedBase64VariantID.replace('gid://shopify/ProductVariant/', '')
            // let variantId = node.id.replace('gid://shopify/ProductVariant/', '')
            node.id = variantId
          })
          resolve(product)
        } else {
          reject("Could not find product")
        }
      })
      .catch(err => {
        Sentry.captureException(err);
        console.log(err)
        reject(err)
      });
  });
}


teradekAPI.closeProductModal = () => {
  vueModalApp.product = null;
  vueModalApp.timeToLoadVariants = false;
  vueModalApp.showModal = false;
  vueModalApp.handleChangeUrlBack();
  // document.body.style.overflow = 'auto'
  // $('body').css('overflow', 'auto')
  bodyScrollLock.enableBodyScroll();
  bodyScrollLock.clearAllBodyScrollLocks();
  window.abc = document;
  window.removeEventListener('popstate', teradekAPI.popStateListener);
  // history.back();
}


teradekAPI.getAdditionalProductInfo = (productId) => {
  let product = allProductInfo[productId]
  if (!product) {
    return null
  } else {
    return product;
  }
}


teradekAPI.popStateListener = (event) => {
  teradekAPI.closeProductModal();
}


teradekAPI.addOneToCart = (variantId) => {
  let formData = [
    { name: "form_type", value: "product" }
    , { name: "utf8", value: "✓" }
    , { name: "id", value: variantId }
    , { name: "quantity", value: "1" }
  ];
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $.param(formData),
    dataType: 'json'
  }).done(function (response) {
    $.ajax({
      type: 'GET',
      url: '/cart?view=cart-info.json',
      success: function (resp) {
        try {
          let cart = JSON.parse(resp)
          vueCartApp.updateSidecart(cart)
          $('[data-header-cart-count]').attr('data-header-cart-count', cart.item_count).toggleClass('visible', cart.item_count > 0);
        } catch(err) {
          Sentry.captureException(err);
        }
      }
    });
  }).fail(function (response) {
    try {
      let responseText = JSON.parse(response.responseText)
      if (responseText && responseText.description && responseText.description.indexOf("already sold out") === -1) {
        Sentry.addBreadcrumb({
          category: 'cart',
          message: 'Variant ID: ' + variantId,
          level: Sentry.Severity.Info
        });
        Sentry.captureException(response);
        alert(responseText.description)
      } else if (responseText && responseText.description) {
        alert(responseText.description)
      }
    } catch(err) {
      Sentry.captureException(err);
    }

    // try {
    //   var responseText = JSON.parse(response.responseText);
    //   errorText = responseText.description;
    //   alert(errorText)
    // } catch (error) {
    //   errorText = "".concat(response.status, " ").concat(response.statusText);

    //   if (response.status === 401) {
    //     errorText = "".concat(errorText, ". Try refreshing and logging in.");
    //   }
    //   alert(errorText)
    // }
  });
}


teradekAPI.updateCartItem = (value, updateKey, cartApp) => {
  let variantId = updateKey.split(':')[0];
  let _this = cartApp;
  let expectedQuantity = parseInt(value);
  let currentItem = _this.cartItems.find(each => parseInt(each.variant_id) === parseInt(variantId));
  let currentQuantity = parseInt(currentItem.quantity);
  if (currentQuantity === expectedQuantity) {
    return;
  }
  _this.errorMessage = null;
  axios({
    method: "POST",
    url: '/cart/change.js',
    data: {
      quantity: parseInt(value),
      id: variantId
    }
  })
  .then((response) => {
    let changedItem = response.data.items.length && response.data.items.find(each => parseInt(each.variant_id) === parseInt(variantId));
    if (changedItem) {
      let actualQuantity = changedItem.quantity
      if (actualQuantity !== expectedQuantity) {
        let quantityDiff = expectedQuantity-actualQuantity
        let quantityAdded = expectedQuantity-currentQuantity
        if (quantityDiff > 0) {
          _this.errorMessage = `Only ${actualQuantity} stock left of ${currentItem.title}`
        }
      }
    }
    axios({
      method: 'GET',
      url: '/cart?view=cart-info.json'
    })
    .then(response => {
      try {
        let cart = response.data
        _this.updateSidecart(cart)
      } catch(err) {
        Sentry.captureException(err);
      }
    })
    .catch(err => {
      Sentry.captureException(err);
      console.log(err)
    });;
  })
  .catch(err => {
    Sentry.captureException(err);
    console.log(err)
    alert('Error modifying cart')
  })
}

